import "./otherCurrencies.scss";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import { useSelector } from "react-redux";
import moment from "jalali-moment";

import PrevButton from "../../assets/icons/icones moj-06.svg";
import NextButton from "../../assets/icons/icones moj-05.svg";
import whitePrevButton from "../../assets/icons/white-right-icon.png";
import whiteNextButton from "../../assets/icons/white-left-icon.png";
import otherCurTitle from "../../assets/icons/icones moj-03.svg";
import whiteOtherCurTitle from "../../assets/icons/icones moj-21.svg";
import CurrencyCard from "../CurrencyCard";
import Spinner from "../Spinner";

const OtherCurrencies = ({ currencies, isLoading }) => {
  const [jalali, setJalali] = useState("");
  const otherCurrencies = currencies?.filter(
    (cur) =>
      cur.CurrencyId !== 1 &&
      cur.CurrencyId !== 3 &&
      cur.CurrencyId !== 5 &&
      cur.CurrencyId !== 21
  );
  const sortedOtherCurrencies = otherCurrencies
    .slice()
    .sort((a, b) => a.id - b.id);

  // store
  const darkThemeFromStore = useSelector(
    (state) =>
      // console.log(state);
      state.Reducer.darkTheme
  );

  useEffect(() => {
    const timeSortedCurs = currencies
      .slice()
      .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    moment.locale("fa", { useGregorianParser: true });
    setJalali(moment(timeSortedCurs[0]?.updatedAt).format("HH:mm YYYY/MM/DD"));
  }, [currencies]);

  return (
    <div
      className={`other-currency-container ${isLoading ? "h-isloading" : ""} ${
        darkThemeFromStore ? "dark" : ""
      }`}
    >
      <div className="title">
        <img src={whiteOtherCurTitle} alt="ارز های دیگر" />
        <h1>نرخ ارز های دیگر</h1>
        <div className="latest-update mx-3 text-sm border-2 rounded-md px-1">{jalali}</div>
      </div>
      {isLoading ? (
        <Spinner isDark={false} />
      ) : (
        <div className="swiper-container">
          <div className="swiper-prev">
            <img alt="بعدی" src={whitePrevButton} className="" />
          </div>
          <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            spaceBetween={0}
            // pagination={{ clickable: true }}
            //   scrollbar={{ draggable: true }}
            navigation={{
              prevEl: ".swiper-prev",
              nextEl: ".swiper-next",
            }}
            speed={600}
            slidesPerView={1}
            onSlideChange={() => {}} // Disable onSlideChange event
            onSwiper={(swiper) => swiper.slideTo(0, 0, false)} // Force slide to first position
          >
            <SwiperSlide key="slide1" className="five-grid">
              {sortedOtherCurrencies?.slice(0, 10).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide2" className="five-grid">
              {sortedOtherCurrencies?.slice(10, 16).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide3" className="four-grid">
              {sortedOtherCurrencies?.slice(0, 8).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide4" className="four-grid">
              {sortedOtherCurrencies?.slice(8, 16).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>

            <SwiperSlide key="slide5" className="three-grid">
              {sortedOtherCurrencies?.slice(0, 6).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide6" className="three-grid">
              {sortedOtherCurrencies?.slice(6, 12).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide7" className="three-grid">
              {sortedOtherCurrencies?.slice(12, 16).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>

            <SwiperSlide key="slide8" className="two-grid">
              {sortedOtherCurrencies?.slice(0, 4).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide9" className="two-grid">
              {sortedOtherCurrencies?.slice(4, 8).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide10" className="two-grid">
              {sortedOtherCurrencies?.slice(8, 12).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide11" className="two-grid">
              {sortedOtherCurrencies?.slice(12, 16).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>

            <SwiperSlide key="slide12" className="one-grid">
              {sortedOtherCurrencies?.slice(0, 2).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide13" className="one-grid">
              {sortedOtherCurrencies?.slice(2, 4).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide14" className="one-grid">
              {sortedOtherCurrencies?.slice(4, 6).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide15" className="one-grid">
              {sortedOtherCurrencies?.slice(6, 8).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide16" className="one-grid">
              {sortedOtherCurrencies?.slice(8, 10).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide17" className="one-grid">
              {sortedOtherCurrencies?.slice(10, 12).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
            <SwiperSlide key="slide18" className="one-grid">
              {sortedOtherCurrencies?.slice(12, 14).map((cur) => {
                return (
                  <CurrencyCard key={cur.id} isPopular={false} currency={cur} />
                );
              })}
            </SwiperSlide>
          </Swiper>
          <div className="swiper-next">
            <img alt="قبلی" src={whiteNextButton} className="" />
          </div>
        </div>
      )}
    </div>
  );
};

export default OtherCurrencies;
